import './styles.css';

import { Box, chakra, Image, shouldForwardProp } from '@chakra-ui/react';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { isValidMotionProp, motion } from 'framer-motion';
import i18next from 'i18next';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { gameListFromBottom } from '../../../animateConstant';
import { COMMON_WEB_PATH } from '../../../constant';
import { languageTransfer } from '../../../utils/languageTransfer';
import GameItem from '../../GameItem/GameItem';
import LoadingBlock from '../../Loading/LoadingBlock';
import NotFound from '../../ProgressBlock/NotFound';
const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop)
});

const GameSlideSelector = () => {
  const [searchParams] = useSearchParams();

  const splideRef = useRef(null);

  /* B:圖片探測解析完後，做一次(debounced)重新複製，讓 loop clone 拿到有效 src */
  const refreshTimerRef = useRef(null);
  const scheduleRefresh = () => {
    clearTimeout(refreshTimerRef.current);
    refreshTimerRef.current = setTimeout(() => {
      const splide = splideRef.current?.splide;
      if (!splide) return;
      splide.refresh();
      // refresh 會重建輪播、洗掉 coverflow class，補回來
      setTimeout(() => updateSlideClasses(splide), 0);
    }, 150);
  };

  const searchParamsType = searchParams.get('type') || 'Popular';

  const [isLoading, setIsLoading] = useState(true);

  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const { newGameList, exclusiveBrandGames, highlightGames, topGameList } =
    isHandleAllGame || {};

  const gameList = useMemo(() => {
    // 特別處理customSubType="New" 的情況
    if (searchParamsType === 'New') {
      return (newGameList || []).slice(0, 10); // 直接返回 newGameList 只返回前8個 不需要其他過濾
    }

    // 特別處理customSubType="exclusiveBrandGames"的情況 顯示全部獨家遊戲
    if (searchParamsType === 'exclusiveBrandGames') {
      return exclusiveBrandGames || []; // 直接返回全部獨家遊戲
    }

    // 特別處理customSubType="Popular"的情況 從highlightGames取前40個
    else {
      // const gamesArray = Object.values(highlightGames || {});
      const gamesArray = topGameList || [];

      // 根據 game_tags 排序
      // const sortedGames = gamesArray.sort((a, b) => {
      //   const aHotTag = a.game_tags?.find((tag) => tag.startsWith('hot_'));
      //   const bHotTag = b.game_tags?.find((tag) => tag.startsWith('hot_'));

      //   // 如果沒有 hot tag，排到最後面
      //   if (!aHotTag) return 1;
      //   if (!bHotTag) return -1;

      //   const aOrder = parseInt(aHotTag.split('_')[1]);
      //   const bOrder = parseInt(bHotTag.split('_')[1]);

      //   return aOrder - bOrder;
      // });
      const sortedGames = gamesArray;

      // 過濾掉沒有 hot tag 的遊戲並返回前40個
      return [...sortedGames, ...sortedGames].slice(0, 40);
    }
  }, [searchParamsType, newGameList, exclusiveBrandGames, topGameList]);

  const updateSlideClasses = (splideInstance) => {
    const splide = splideInstance || splideRef.current?.splide;
    if (!splide) return;

    const slides = splide.Components.Slides.get();
    const currentIndex = splide.index;

    slides.forEach((slide) => {
      slide.slide.classList.remove('is-prev-all', 'is-next-all');

      const realIndex = slide.index;

      if (realIndex === currentIndex) return;

      if (realIndex < currentIndex) {
        slide.slide.classList.add('is-prev-all');
      } else {
        slide.slide.classList.add('is-next-all');
      }
    });
  };

  // useEffect(() => {
  //   if (!isLoading && splideRef.current?.splide) {
  //     const splide = splideRef.current.splide;
  //     splide.refresh();
  //     // 確保在資料載入後且 loading 結束時，強制跳轉到 start index
  //     if (gameList?.length > 3) {
  //       splide.go(3);
  //     }
  //     updateSlideClasses(splide);
  //   }
  // }, [isLoading, gameList]);

  useEffect(() => {
    if (isLoading) {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  }, [isLoading]);

  useEffect(() => {
    setIsLoading(true);
  }, [searchParamsType]);

  return (
    <>
      <LoadingBlock size="50px" commonLoading={isLoading}>
        {gameList?.length === 0 && <NotFound />}
        <ChakraBox
          key={searchParamsType}
          {...gameListFromBottom}
          position="relative"
          h="100%"
        >
          <Splide
            ref={splideRef}
            hasTrack={false}
            className="mask_splide h-full w-full"
            onMounted={(splide) => {
              setTimeout(() => {
                updateSlideClasses(splide);
              }, 0);
            }}
            onScroll={(splide) => updateSlideClasses(splide)}
            onReady={(splide) => updateSlideClasses(splide)}
            onMove={(splide) => updateSlideClasses(splide)}
            onMoved={(splide) => updateSlideClasses(splide)}
            options={{
              type: 'loop',
              // padding: "20%",
              // drag: "free",
              paddingTop: '20px',
              gap: -30,
              start: 0,
              perMove: 1,
              arrows: true,
              fixedWidth: `350px`,
              // perPage: 5,
              pagination: false,
              focus: 'center',
              lazyLoad: 'nearby',
              updateOnMove: true
            }}
          >
            <Box className="splide__arrows">
              <button
                className="splide__arrow splide__arrow--prev"
                style={{
                  background: 'none',
                  width: '100px',
                  height: '50px'
                }}
              >
                <Image src={`${COMMON_WEB_PATH}/theOne/menu_arrow_right.png`} />
              </button>
              <button
                className="splide__arrow splide__arrow--next"
                style={{
                  background: 'none',
                  width: '100px',
                  height: '50px'
                }}
              >
                <Image src={`${COMMON_WEB_PATH}/theOne/menu_arrow_left.png`} />
              </button>
            </Box>
            <SplideTrack>
              {[...gameList]?.map((item, index) => {
                const gameName =
                  item?.[
                    `gameName${languageTransfer({
                      lang: i18next.language
                    })}`
                  ];
                const gameNameEn = item?.gameNameEn;
                const platform = item?.game_platform;
                const gameSubType = item?.game_subtype;

                const gameCode = item?.gameCode;
                const gameType = item?.gameType;

                return (
                  <SplideSlide key={index}>
                    <GameItem
                      gameProps={{
                        gameName,
                        platform,
                        gameCode,
                        gameType,
                        gameNameEn,
                        gameSubType
                      }}
                      originProps={item}
                      //   itemClass={`!h-[330px]`}
                      itemIndex={index}
                      isNormalImage
                      /* longLayout 是版型(卡片比例),longImage 是圖片來源。
                         兩個都要給,GameItem 裡是 longLayout && longImage 才吃長圖。
                         長圖缺圖時 gameImageSource 會自動退回一般方圖,不會破圖。 */
                      longLayout
                      longImage
                      machineLayout
                      centerMode={splideRef.current?.splide?.index === index}
                      preloadResolve
                      onImageResolved={scheduleRefresh}
                    />
                  </SplideSlide>
                );
              })}
            </SplideTrack>
          </Splide>
        </ChakraBox>
      </LoadingBlock>
    </>
  );
};

export default GameSlideSelector;
